const services = [
  {
    slug: "assainissement",
    img: "/images/1.webp",
    heroImg: "/images/project/assainissement3.JPEG",
    title: "Assainissement",
    desc: "Individuel, collectif ou tout à l’égout (réseau d’eau pluviale ou usée).",
    intro:
      "Nous posons vos réseaux d’assainissement conformément aux prérequis de l'étude de sol du SPANC afin de sécuriser votre chantier et l’environnement local.",
    content: [
      "Notres savoir-faire va de la création complète d'un assainissement individuel, collectif et public (tout à l'égout) et également la remise en conformité d'un réseau déja existant. Nous intervenons aussi sur de la réfection et du dépannage.",
    ],
    quote:
      "Chaque réseau est dimensionné sur mesure pour protéger la nappe phréatique, vos ouvrages et la qualité de vie des riverains.",
    highlights: [
      {
        title: "Pose des ouvrages",
        text: "Implantation des fosses, tranchées drainantes, pompes de relevage et raccordement aux réseaux existants.",
      },
      {
        title: "Mise en service certifiée",
        text: "Tests d’étanchéité, contrôles finaux et accompagnement lors des visites réglementaires.",
      },
    ],
    deliverables: [
      "Plans d’exécution et schémas des réseaux enterrés",
      "Conseils d’entretien pour garantir la pérennité des installations",
    ],
  },
  {
    slug: "nivellement-terrassement",
    img: "/images/2.webp",
    heroImg: "/images/project/terrassement3.JPEG",
    title: "Nivellement & Terrassement",
    desc: "Préparation de terrain en vue d’une construction (maison, terrasse, etc.).",
    intro:
      "Nous préparons vos plateformes avec précision pour accueillir maisons individuelles, bâtiments industriels ou zones de voirie.",
    content: [
      "Après décaissement, nous assurons la gestion des déblais/remblais et la création des accès chantier. Nos équipes utilisent un guidage laser pour livrer une préparation millimétrée.",
      "Nous pouvons intégrer les réseaux d'eau potable, électrique et télécom, stabiliser les sols avec des matériaux adaptés et compacter chaque couche selon les normes en vigueur. Votre projet démarre ainsi sur une base saine, plane et prête à bâtir.",
    ],
    quote:
      "Un terrassement précis réduit les coûts structurels et protège le bâti sur le long terme.",
    highlights: [
      {
        title: "Études de plateforme",
        text: "Relevés topographiques, cubatures et proposition d’optimisation des déblais/remblais.",
      },
      {
        title: "Gestion des matériaux",
        text: "Tri, évacuation, valorisation des terres et apport de matériaux normés.",
      },
      {
        title: "Compactage contrôlé",
        text: "Contrôle de densité et traçabilité des points de compactage pour valider vos fondations.",
      },
    ],
    deliverables: [
      "Plateforme nivelée prête à recevoir les fondations",
      "Conseils sur le phasage des travaux et les accès chantier",
    ],
  },
  {
    slug: "amenagement-exterieur",
    img: "./../images/3.webp",
    heroImg: "/images/project/terrassement6.webp",
    title: "Aménagement extérieur",
    desc: "Pavage, enrobé, gravillonnage et autres travaux d’extérieur.",
    intro:
      "Nous valorisons vos abords avec des solutions esthétiques et durables : accès, parkings, cours, terrasses et chemins piétons.",
    content: [
      "Nos équipes conçoivent chaque aménagement en fonction de l’usage : structure drainante pour les zones carrossables, finitions antidérapantes pour les espaces piétons, choix des matériaux en harmonie avec l’architecture existante.",
      "Nous intégrons également les réseaux d’éclairage, les bordures et les dispositifs de gestion des eaux pluviales pour offrir un extérieur fonctionnel et facile à entretenir.",
    ],
    quote:
      "Un aménagement extérieur bien pensé améliore votre confort de vie et valorise votre bien.",
    highlights: [
      {
        title: "Design sur mesure",
        text: "Propositions de matériaux (enrobé, pavé, gravillon, etc.).",
      },
      {
        title: "Finitions soignées",
        text: "Pose des bordures, joints et raccords précis",
      },
      {
        title: "Gestion des eaux pluviales",
        text: "Implantation de caniveaux pour éviter les flaques et l’érosion.",
      },
    ],
    deliverables: ["Plan d’exécution et choix matériaux validés"],
  },
  {
    slug: "demolition",
    img: "./../images/4.webp",
    heroImg: "/images/project/tugauttp_entrepot.JPG",
    title: "Démolition",
    desc: "Interventions réalisées dans le respect des normes environnementales.",
    intro:
      "Nous sécurisons vos chantiers de démolition partielle ou totale en coordonnant les études, la déconstruction et la gestion des déchets.",
    content: [
      "Chaque intervention démarre par un diagnostic structurel et déchets, suivi d’un plan de prévention pour protéger les riverains et les équipes. Nous installons les équipements nécessaires, procédons à la dépose mécanique ou manuelle selon les contraintes, puis à la valorisations des déchets",
      "Les matériaux sont triés et évacués vers des filières agréées. Le site est livré propre, prêt à accueillir un nouveau projet ou à être remis en état naturel.",
    ],
    quote:
      "La maîtrise des risques et la traçabilité des déchets sont au cœur de nos chantiers de démolition.",
    highlights: [
      {
        title: "Déconstruction contrôlée",
        text: "Méthodes manuelles ou mécaniques adaptées à l’environnement urbain ou rural.",
      },
      {
        title: "Gestion des déchets",
        text: "Tri sélectif, pesées et bordereaux pour assurer la conformité réglementaire.",
      },
    ],
    deliverables: ["Rapport de fin de travaux avec nivellement du terrain"],
  },
  {
    slug: "location-de-benne",
    img: "/images/5.webp",
    heroImg: "/images/project/locPelle.webp",
    title: "Location de benne",
    desc: "Bennes à gravats (10 m³), DIB (30 m³) ou végétaux (30 m³).",
    intro:
      "Nous mettons à disposition des bennes adaptées à vos flux : gravats, déchets inertes, DIB ou déchets verts.",
    content: [
      "Nos conseillers dimensionnent la benne selon le volume réel et la nature des matériaux pour éviter les rotations inutiles. Nous gérons les autorisations de voirie si nécessaire et planifions les enlèvements au plus près de vos besoins.",
      "Les déchets sont transportés vers des centres agréés.",
    ],
    quote:
      "Une logistique fluide des déchets améliore la sécurité du chantier.",
    highlights: [
      {
        title: "Capacités variées",
        text: "De 10 à 30 m³ pour répondre à tous les types de chantiers.",
      },
      {
        title: "Souplesse de collecte",
        text: "Livraison express, rotation programmée ou à la demande selon l’avancement.",
      },
    ],
    deliverables: [
      "Bordereaux de suivi pour chaque tonnage",
      "Recommandations de tri pour optimiser vos coûts",
    ],
  },
  {
    slug: "location-pelle-chauffeur",
    img: "/images/6.webp",
    heroImg: "/images/project/demolition.webp",
    title: "Location de pelle avec chauffeur",
    desc: "Mise à disposition de pelle avec conducteur pour les professionnels.",
    intro:
      "Bénéficiez d’opérateurs expérimentés et d’un parc d’engins entretenus pour sécuriser vos travaux de terrassement, fouilles ou manutentions lourdes.",
    content: [
      "Nous proposons des pelles à chenilles, de 800kg à 8 tonnes, équipées des accessoires nécessaires (godets, BRH, pinces, cailleur rotatif). Nos chauffeurs travaillent selon vos procédures QSE et s’intègrent facilement à vos équipes.",
    ],
    quote:
      "Un conducteur qualifié augmente la productivité et réduit l’usure de vos chantiers sensibles.",
    highlights: [
      {
        title: "Opérateurs certifiés",
        text: "CACES à jour expérience multi-chantiers.",
      },
      {
        title: "Parc entretenu",
        text: "Machines récentes, suivies des maintenance et contrôle périodique valide.",
      },
      {
        title: "Contrats flexibles",
        text: "Location à la journée ou demi journée.",
      },
    ],
    deliverables: [
      "Fiche machine et attestations d’assurance",
      "Planning d’intervention du chauffeur",
      "Rapport quotidien des travaux effectués",
    ],
  },
];

export default services;
